import React from 'react'
import PropTypes from 'prop-types'
import {
  Message,
  MessageBox,
  MessageContainer,
  UserIcon,
  ModeratorIcon,
  UserIconContainer,
  Username,
} from '../style'
import { useTranslation } from 'react-i18next'
import MessageWithLink from './MessageWithLink'
import { useSelector } from 'react-redux'
import { selectCurrentStore } from '../../../reducers/storeSlice'
import { CustomerRoles } from '../../../constants/customerRoles'

export const CommonMessage = React.memo(function CommonMessage({
  message,
  isDesktop,
  getModeratorColorByUsername,
}) {
  const { t } = useTranslation()
  const isModeratorMessage = message.role === CustomerRoles.MODERATOR
  const store = useSelector(selectCurrentStore)
  const clickeableLinks = store.storeConfigurations.features.clickeableLinks
  const textMessage = (message) => {
    if (message.type === 'deleted') {
      return t('chat.deletedMessage')
    }
    return message.text
  }
  const showMessage = message !== null

  return (
    <>
      {showMessage && (
        <MessageContainer isModerator={isModeratorMessage} isDesktop={isDesktop}>
          <MessageBox>
            <UserIconContainer>
              {isModeratorMessage ? (
                <ModeratorIcon isDesktop={isDesktop} />
              ) : (
                <UserIcon isDesktop={isDesktop} />
              )}
            </UserIconContainer>
            <Username
              color={isModeratorMessage ? getModeratorColorByUsername(message.username) : undefined}
              isDesktop={isDesktop}
            >{`${message.username}: `}</Username>
            {clickeableLinks === true || isModeratorMessage ? (
              <MessageWithLink logType="click-url-in-chat" isDesktop={isDesktop}>
                <Message isDesktop={isDesktop} data-test="user-message">
                  {textMessage(message)}
                </Message>
              </MessageWithLink>
            ) : (
              <Message isDesktop={isDesktop} data-test="user-message">
                {textMessage(message)}
              </Message>
            )}
          </MessageBox>
        </MessageContainer>
      )}
    </>
  )
})

CommonMessage.propTypes = {
  isDesktop: PropTypes.bool,
  message: PropTypes.object.isRequired,
  getModeratorColorByUsername: PropTypes.func,
}
